import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase/config';

// Uploads a File to `${folder}/${timestamp}-${name}` and returns its download
// URL. Shared by the settings form, team management, and any section that
// uploads images, so the upload path lives in one place.
export const uploadToStorage = async (file, folder) => {
  const storageRef = ref(storage, `${folder}/${Date.now()}-${file.name}`);
  const snap = await uploadBytes(storageRef, file);
  return getDownloadURL(snap.ref);
};
